<app-claim-view-worker
  *ngIf="claimRol === 'Trabajador' || claimRol === 'Representante gremial'"
></app-claim-view-worker>
<app-claim-view-employer
  *ngIf="claimRol === 'Empleador'"
></app-claim-view-employer>
<app-claim-view-colective
  *ngIf="isCollectiveClaim()"
></app-claim-view-colective>
<app-claim-view-multi *ngIf="isMultiClaim()"></app-claim-view-multi>
